<template>
    <div v-if="type == 2" class="preview-box" v-loading="loading" element-loading-background="rgba(255, 255, 255, 1)">
        <div v-for="(img, index) in images" :key="index" :style="{ 'z-index': index >= imgLayer ? index + 1 : index }"
            style="position: absolute; left: 0; top: 0; width: 100%; height: 100%">
            <img :src="img" alt="" />
        </div>

        <div :id="`three-${id}`" :style="{ 'z-index': imgLayer }"
            style="position: absolute; left: 0; top: 0; width: 1600px; height: 1600px"></div>
    </div>
    <div v-else-if="type == 3" class="preview-box">
        <div :id="`three-${id}`" :style="{ width: width + 'px', height: height + 'px' }"></div>
    </div>
</template>
<script>
import renderModel from "@/utils/renderModel.js";

export default {
    props: {
        value: {
            type: [Object],
        },
        images: {
            type: Array,
        },
        imgLayer: {
            type: Number,
        },
        modelParams: {
            type: Object,
            default: () => { },
        },
        materialList: {
            type: Object,
            default: () => { },
        },
        modelUrl: {
            type: Array,
        },
        id: {
            type: [String, Number],
        },
        width: {
            type: Number,
            default: 600,
        },
        height: {
            type: Number,
            default: 600,
        },
        type: {
            type: Number,
            default: 3,
        },
    },

    data() {
        return {
            modelApi: {},
            loading: true,
        };
    },
    watch: {
        images: {
            handler(val) { },
        },
    },
    methods: {
        moveCamera(params) {
            this.modelApi.moveCamera(params);
        },

        async setMapTexture(params) {
            // console.log(params, this.id)
            return this.modelApi.setMap(params);
        },

        async switchModelByName(params) {
            let parts = params.parts;
            for (let part of parts) {
                await this.modelApi.switchModelByName({
                    name: part,
                    model_url: params.model_url,
                });
            }
        },

        async switchModel(params) {
            await this.modelApi.switchModel(params);
            await new Promise((resolve) => setTimeout(resolve, 200));
            return this.getModelImage();
        },


        async setModelColorMutlipe(params) {
            try {
                this.modelApi.setModelColorMutlipe(params);
                await new Promise((resolve) => setTimeout(resolve, 100));
                return true;
            } catch (error) {
                // 捕获并抛出错误
                throw error;
            }
        },


        async setModelColor(params) {
            try {
                await this.modelApi.setModelColor(params);
                await new Promise((resolve) => setTimeout(resolve, 100));
                return true;
            } catch (error) {
                // 捕获并抛出错误
                throw error;
            }
        },

        async getModelImage() {
            let img = await this.modelApi.toDataURL("image/png");
            return img;
        },

        async setNormalMap(params) {
            await this.modelApi.setNormalMap(params);
        },

        async importScene(json) {
            await this.modelApi.importScene(json);
        },

        async init() {
            // 直接初始化 renderModel 实例
            this.modelApi = new renderModel(`#three-${this.id}`);
            // 构建初始化参数
            const params = {
                modelParams: this.modelParams,
                materialList: this.materialList,
                targetSize: 2,
                fileParams: Array.isArray(this.modelUrl)
                    ? this.modelUrl
                    : [this.modelUrl],
            };

            // 检查文件参数是否有效
            if (!params.fileParams[0] || !params.fileParams[0].url) {
                this.loading = false;
                return true;
            }

            try {
                // 延迟 100ms 后初始化模型
                await new Promise((resolve) => setTimeout(resolve, 100));
                await this.modelApi.init(params);
            } catch (error) {
                // 处理初始化过程中的错误
                console.error("模型初始化失败:", error);
                throw error;
            } finally {
                // 无论初始化成功与否，都将 loading 状态设置为 false
                this.loading = false;
            }

            return true;
        },
    },
};
</script>
<style lang="scss" scoped>
.preview-box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 600px;
    height: 600px;

    img {
        width: inherit;
        height: inherit;
    }
}

.effect-three {
    position: absolute;
    left: 100%;
    width: 600px;
    height: 600px;
}
</style>
